import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Select from './select';
import Segment from './segment';
import CollapseSegment from './collapseSegment';
import Radio from './radio';
import Switch from './switch';
import Checkboxes from './checkboxes';
import Recommendation from './recommendation.js';
import MedSwitch from './medSwitch';
import asccp from '../service/asccp.js';
import cautionImg from "../assets/images/caution.png"
import warningImg from "../assets/images/warning.png"

const Flow = ({ goToNextPage }) => {
    return (
        <input className="btn btn-primary" type="button" onClick={goToNextPage} value="Next &gt;" />
    );
};

const BackFlow = ({ goToPrevPage, margin = "0px 10px 0px 0px" }) => {
    return (
        <input style={{margin:margin, minWidth:"125px"}} className="btn btn-secondary" type="button" onClick={goToPrevPage} value="&lt; Back" />
    );
};

const StartOverFlow = ({ startOver, margin = "0px 10px 0px 0px" }) => {
    return (
        // todo: add confirmation popup
        <input style={{margin:margin, minWidth:"125px"}} className="btn btn-primary" type="button" onClick={startOver} value="Start Over &gt;" />
    );
};

var closeOldPopUp = null;

function setPopUp(closePopUp) {
    if(closeOldPopUp) {
        closeOldPopUp();
    }
    closeOldPopUp = closePopUp;
}

var calcIndex = 0;
var showFacts = false;


function transformReference(reference, prefix) { 
        
    if (reference == "2012") {
        return "<a href='https://www.asccp.org/Assets/405b4550-593f-40a7-ae25-0c783de95b0d/635912114192570000/asccp-updated-guidelines-3-21-13-pdf' target='_blank'>" + prefix + 
          "Massad SL, Einstein MH, Huh WK, et al. 2012 updated consensus guidelines for the management of abnormal cervical cancer screening tests and cancer precursors. J Low Genit Tract Dis 2013;17:S1–S27." +
          "</a>";
    }

    if (reference == "2019") {
      return "<a href='https://journals.lww.com/jlgtd/Fulltext/2020/04000/2019_ASCCP_Risk_Based_Management_Consensus.3.aspx' target='_blank'>" + prefix + 
          "Perkins RB, Guido RS, Castle PE, et al. 2019 ASCCP risk-based management consensus guidelines for abnormal cervical cancer screening tests and cancer precursors. J Low Genit Tract Dis 2020;24:102–31."      +
          "</a>";       
    }
    
    if (reference == "Egeman" || reference == "Egemen") {
      return "<a href='https://journals.lww.com/jlgtd/Fulltext/2020/04000/Risk_Estimates_Supporting_the_2019_ASCCP.4.aspx' target='_blank'>" + prefix + 
          "Egemen D, Cheung LC, Chen X, et al. Risk estimates supporting the 2019 ASCCP Risk-Based Management Consensus Guidelines. J Low Genit Tract Dis 2020;24:132–43." +
          "</a>";
    }
    
    if (reference == "Demarco") {
      return "<a href='https://journals.lww.com/jlgtd/Fulltext/2020/04000/A_Study_of_Partial_Human_Papillomavirus_Genotyping.5.aspx' target='_blank'>" + prefix + 
          "Demarco M, Egemen D, Raine-Bennett TR, et al. A study of partial human papillomavirus genotyping in support of the 2019 ASCCP risk-based management consensus guidelines. J Low Genit Tract Dis 2020;24:144–7." +
          "</a>";
    }
    
    if (reference == "URL") {
      return "<a href='https://cervixca.nlm.nih.gov/RiskTables/' target='_blank'>" + prefix + 
          "Risk estimates supporting the 2019 ASCCP Risk-Based Management Consensus Guidelines. https://cervixca.nlm.nih.gov/RiskTables/" +
          "</a>";
    }

    if (reference == "2019-Erratum") {
      return "<a href='https://journals.lww.com/jlgtd/Fulltext/2021/10000/Erratum__2019_ASCCP_Risk_Based_Management.16.aspx' target='_blank'>" + prefix + 
          "Perkins RB, Guido RS, Castle PE, et al. Erratum: 2019 ASCCP Risk-Based Management Consensus Guidelines for Abnormal Cervical Cancer Screening Tests and Cancer Precursors. J Low Genit Tract Dis 2021;25:330-331." +
          "</a>";
    }

    if (reference == "Letter") {
        return "<a href='https://journals.lww.com/jlgtd/fulltext/2024/01000/2019_asccp_risk_based_management_consensus.2.aspx' target='_blank'>" + prefix + 
            "Perkins RB, Guido RS, Castle PE, et al. 2019 ASCCP Risk-Based Management Consensus Guidelines: Updates Through 2023. J Low Genit Tract Dis 2024;28:3-6." +
            "</a>";
    }
      
    if (reference == "Dual") {
        return "<a href='https://journals.lww.com/jlgtd/fulltext/2024/04000/recommendations_for_use_of_p16_ki67_dual_stain_for.2.aspx' target='_blank'>" + prefix + 
            "Clarke MA, Wentzensen N, Perkins RB, et al. Recommendations for Use of p16/Ki67 Dual Stain for Management of Individuals Testing Positive for Human Papillomavirus. J Low Genit Tract Dis 2024;28:124-130." +
            "</a>";
    }

    if (reference == "Extended") {
        return "<a href='https://journals.lww.com/jlgtd/fulltext/2025/04000/applying_results_of_extended_genotyping_to.5.aspx' target='_blank'>" + prefix + 
            "Massad SL, Clarke MA, Perkins RB, et al. Applying Results of Extended Genotyping to Management of Positive Cervicovaginal Human Papillomavirus Test Results: Enduring Guidelines. J Low Genit Tract Dis. 2025;29(2):134-143." +
            "</a>";
    }

    if (reference == "self-collection") {
        return "<a href='https://journals.lww.com/jlgtd/fulltext/2025/04000/self_collected_vaginal_specimens_for_hpv_testing_.6.aspx' target='_blank'>" + prefix + 
            "Wentzensen N, Massad SL, Clarke MA, et al. Self-Collected Vaginal Specimens for HPV Testing: Recommendations From the Enduring Consensus Cervical Cancer Screening and Management Guidelines Committee. J Low Genit Tract Dis. 2025;29(2):144-152." +
            "</a>";
    }

    return "";
}

function specialPopulationText( population) {

    if (population == "Long Term") {
        return "<b>Long term follow-up:</b> After the initial intensive surveillance period, continued surveillance at 3-year intervals is recommended for at least 25 years after treatment of high-grade histology (histologic HSIL, CIN 2, CIN 3, or AIS) or high-grade cytology (HSIL or persistent ASC-H) even if this is beyond the age of 65 years (BII). When patients with a history of treated high-grade histology or cytology reach the age of 65 years, if they have completed the initial 25-year surveillance period, continued surveillance at 3-year intervals is acceptable and may continue as long as the patient is in reasonably good health (BIII). Discontinuation of screening is recommended if a patient has a limited life expectancy. Management according to the highest-grade abnormality found on histology or cytology is recommended.";
    }

    if (population == "Pregnancy") {
        return "<b>During pregnancy:</b> Endocervical curettage, endometrial biopsy, and treatment without biopsy are unacceptable. A diagnostic excisional procedure or repeat biopsy is recommended only if cancer is suspected based on cytology, colposcopy, or histology.";
    }
    
    if (population == "Over 65") {
        return "<b>For patients who undergo testing at ages >65 years, manage according to guidelines for patients 25-65 years.<br />\n<br />\n" +
            "Over 65 with a history of abnormalities: </b>Continue surveillance testing if the patient is in reasonably good health and testing is feasible. Discontinuation of surveillance is recommended for individuals with a limited life expectancy.";
    }
    
    if (population == "Rarely") {
         return "The management recommendation provided was based on data from patients with a history of screening, as data on rarely screened patients is lacking.";
    }
  
    if (population == "HPV16-18-Else+" || population == "HPV16-18+" || population == "HPV16+") {
        return "The management recommendation provided was based on data from HPV positive patients without genotyping, as data on patients with specific genotypes is lacking.";
    }

    if (population == "Multiple Colposcopies") {
        return "<b>Multiple Colposcopies:</b> When managing patients with multiple colposcopy results, prior cytologic high-grade abnormalities (ASC-H, HSIL, AGC) increases the patient’s risk and should be considered in their management."
    }

    return population;
}

function referenceNumber(references, reference) {
    if (!reference || reference.length == 0) {
        return ""
    }
    
    let superscripts = ["&#x00B9", "&#x00B2", "&#x00B3", "&#x2074", "&#x2075", "&#x2076", "&#x2077", "&#x2078", "&#x2079"]
    let rr = reference.split(',');
    var result = "";
    for(var i=0;i<rr.length;i++) {
        let s = rr[i].trim();
        let idx = references.indexOf(s);
        if (idx >= 0) {
            if (result.length > 0) {
                result += "&#x1D112";
            }
            result += superscripts[idx];
        }
    }
    
    return result;
}

function mapContent(c, diagnoses, facts, setVariable, getVariable, state, diagnosis, sortClicked, algorithm, setcalResult, references, togglePDF, figures) {
    
    if(facts != null) {
        if (facts[c.id]) {
            console.log(facts[c.id]);
        }
    }

    let onSelected = (id, choice) => {
        console.log(id, choice);
        setVariable(id, choice.value || choice.text);
        if(id == "clinical_situation") {
            setVariable("diagnosis", choice.value || choice.text);
        }
    }

    var tempDiagnosis;
    if(diagnosis != null) {
        tempDiagnosis = diagnoses.find(d => d.title == diagnosis)
    }

    if (c.id == "diagnosis") {
        c.choices = diagnoses.map(d => { return { "text": d.title } })
        c.choices.unshift({ "text": "Select" });
    }

    if (c.type == 'select') {
        return (<Select content={c} onSelected={onSelected} defaultSelected={getVariable("diagnosis")} key={c.id} />);
    }
    if (c.type == 'segment' || c.type == 'choice' || c.type == 'horizontal') {
        return (<Segment content={c} onSelected={onSelected} key={c.id + c.title + c.text} type={c.type} />);
    }
    if(c.type == 'collapse_segment') {
        return (<CollapseSegment content={c} onSelected={onSelected} key={c.type + c.id} type={c.type} />);
    }
    if (c.type == 'radio') {
        return (<Radio content={c} diagnosis={tempDiagnosis} onSelected={onSelected} key={c.id} />);
    }
    if (c.type == 'switch') {
        return (<Switch content={c} facts={facts[c.id]} setPopUp={setPopUp} showFacts={showFacts} onSelected={onSelected} defaultSelected={getVariable("diagnosis")} key={c.id} />);
    }
    if (c.type == 'checkboxes') {
        return (<Checkboxes content={c} onSelected={onSelected} getVariable={getVariable} defaultSelected={getVariable("diagnosis")} key={c.id} />);
    }
    if (c.type == 'set') {
        asccp.setVariable(c.id, c.choices[0].text)
        return (<div key={c.type + c.id} />);
    }
    if(c.type == 'title') {
        return (<div key={c.text[0]} > <h4>{c.text[0]}</h4></div>);
    }
    if(c.type == 'collapse') {
        if(state == "recommendation" || state == "confirmation") {
            return (
                <div className="card card-rec">
                    <div className="card-body">
                        <h6 className="card-subtitle mb-2 text-muted" style={{paddingBottom:"10px", paddingTop:"10px"}}><b>{c.title}</b></h6>
                        <h6 className="card-subtitle mb-2 text-muted"
                            dangerouslySetInnerHTML={{ __html: c.text }} />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="question question-content">
                    <div className="card-body">
                        {c.title != null ? <h5 className="card-title mb-2 text-muted">&#9432; {c.title}</h5> : ""}
                        <h6 className="card-subtitle mb-2 text-muted"
                            dangerouslySetInnerHTML={{ __html: c.text }} />
                    </div>
                </div>
            );
        }
    }
    if(c.type == 'med_switch') {
        return(<MedSwitch content={c} setSwitch={setVariable} getVariable={getVariable}></MedSwitch>)
    }

    // If we are viewing a calculator, send any c.type==overlay back up to the <CompTool> to render on the right side floating
    if(setcalResult!=null) {
        setcalResult(c, calcIndex)
        calcIndex ++;
    } else if(state == "recommendation" || state == "confirmation") {
        var text = c.text || "";
        if (text) {
            text = text.toString().replace("<pre>", "");
            text = text.replace("</pre>", "");
            text = text.replaceAll("(SOR A)", '<span><u>(SOR A)</u></span>');
            text = text.replaceAll("(SOR B)", '<span><u>(SOR B)</u></span>');
            c.text = text.replaceAll("(SOR C)", '<span><u>(SOR C)</u></span>');
        }
        if(text.includes("<caution>") || text.includes("<warning>")) {
            return (
                <div className="card card-rec">
                    <div className="card-body" onClick={sortClicked}>
                        {c.name != null || c.title != null ? <h5 className="card-title text-muted">{c.name || c.title}</h5>: ""}
                        <div className='grid-2' style={{gridTemplateColumns:"35px auto", padding:"0"}} >
                            {text.includes("<caution>") == true ? <img style={{width:"35px", marginTop:"-15px"}} src={cautionImg}/> : <img style={{width:"35px", marginTop:"-15px"}} src={warningImg}/>}
                            <h6 className="card-subtitle mb-2 text-muted" dangerouslySetInnerHTML={{ __html: c.text }} />
                        </div>
                    </div>
                </div>
            );
        } else {
            var exStyles = (!figures || figures.length == 0) ? "risk_bar-full" : "";
            
            return (<Recommendation content={c} references={references} togglePDF={togglePDF} referenceNumber={referenceNumber} exStyles={exStyles}></Recommendation>);
        }
    } else {
        if (c.type == "stop" || c.type == "error") {
            return (
                <div className="question question-content" style={{backgroundColor: "#ffdcdc"}}>
                    <div className="card-body">
                        {c.name != null || c.title != null ? <h5 className="card-title text-muted">&#9432; {c.name || c.title}</h5> : ""}
                        <h6 className="card-subtitle mb-2 text-muted"
                            dangerouslySetInnerHTML={{ __html: c.text }} />
                            {c.figure && c.figure.length > 0 ? 
                                <ul class="lstn">
                                    {c.figure && c.figure.map(f => {
                                        f = f.replace(/:/g, '');
                                        return (<li key={f}>
                                            <button className='btnTitle' onClick={e => togglePDF((f.split("_")[0]))}><img src={"/assets/" + f + ".png"} /></button>
                                        </li>);
                                    })}
                                </ul>
                                : ""}
                    </div>
                </div>
            );
        }
        return (
            <div className="question question-content" style={{backgroundColor: "#d0d9e5"}}>
                <div className="card-body">
                    {c.name != null || c.title != null ? <h5 className="card-title text-muted">&#9432; {c.name || c.title}</h5> : ""}
                    <h6 className="card-subtitle mb-2 text-muted"
                        dangerouslySetInnerHTML={{ __html: c.text }} />
                </div>
            </div>
        );
    }
}

function renderReferences(refs) {

    var html_references = "";
    if (refs.length > 0) {
        html_references = html_references + transformReference(refs[0], "1. ")
    }
    if (refs.length > 1) {
        html_references = html_references + transformReference(refs[1], "<br/>\n2. ")
    }
    if (refs.length > 2) {
        html_references = html_references + transformReference(refs[2], "<br/>\n3. ")
    }
    return (<div dangerouslySetInnerHTML={{ __html: html_references }}></div>);
}

function renderPopulations(pops) {

    function validPopulations(output) {

        return output; // TODO

        if (!output.data.populations || output.data.populations.length == 0) {
            return []
        }

        var ps = output.data.populations;
        var ageRange = output.patientInfo.ageRange;
        if (ageRange != "Over 65") {
            ps = ps.filter(function (a) { return a !== "Over 65" });
        }
        var results = output.patientInfo.results;
        var results_0 = null;
        if (results.length > 0) {
            results_0 = results[0];
        }

        var cotest = results_0.cotest || "";
        if (cotest.startsWith("HPV16-18-Else+/")) {
            ps = ps.filter(function (a) { return a == "HPV16-18-Else+" || a.startsWith("HPV") == false; });
        } else if (cotest.startsWith("HPV16-18+/")) {
            ps = ps.filter(function (a) { return a == "HPV16-18+" || a.startsWith("HPV") == false });
        } else if (cotest.startsWith("HPV16+/")) {
            ps = ps.filter(function (a) { return a == "HPV16+" || a.startsWith("HPV") == false });
        } else {
            ps = ps.filter(function (a) { return a.startsWith("HPV") == false });
        }

        return ps;
    }

    pops = validPopulations(pops);
    pops = pops.map(specialPopulationText).join("<br/>\n<br/>\n");
    return (<div dangerouslySetInnerHTML={{ __html: pops }}></div>);
}


const Page = ({ page, diagnoses, facts, setVariable, getVariable, goToNextPage, goToPrevPage, startOver, togglePDF, algorithm, setcalResult}) => {
    
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    console.log(facts);
    if(facts != null) {
        if(Object.keys(facts).length != 0) {
            showFacts = true;
        } else {
            showFacts = false;
        }
    }

    let can_answer = (q) => {
        if (q.groups) {
            return true;
        }

        if (q.type == "stop") {
            return true;
        }

        if (!q.choices) {
            return false;
        }

        let choice = q.choices.filter(c => c.enabled);
        return choice.length > 0;
    }

    
    let renderFigures = (figures) => {
        if (figures.length == 0) {
            return (<div />);
        }

        return (
            <ul class="lstn">
                {figures.map(f => {
                    f = f.replace(/:/g, '');
                    return (f.length > 0 ? (<li key={f}>
                        <button className='btnTitle' onClick={e => togglePDF((f.split("_")[0]))}><img src={"/assets/" + f + ".png"} /></button>
                    </li>) : null);
                })}
            </ul>);
    }

    let needs_answer = (q) => {

        if (can_answer(q) == false || q.type == "checkboxes" || q.id == "comorbidities" || q.id == "clinical_situation" || q.id == "special_situations") {
            return false;
        }

        if (q.type == "switch") {
            //let choice = q.groups.filter(g => needs_answer(g)); // choice always comes back as undefined
            if (q.groups.filter(g => needs_answer(g)).length > 0) {
                return true;
            }

            return false;
        }

        if (q.type == "stop")
        {
            return true;
        }

        if (q.value != null  && (q.type == "choice" || q.type == "segment")) {
           // var choice = q.choices.filter(c => c.text === q.value || c.value === q.value); // choice always comes back as undefined
            return q.choices.filter(c => c.text === q.value || c.value === q.value).length == 0;
        }

        if (q.value && q.value.length > 0) {
            return false
        }

        if (q.type == "radio") {
            //let choice = q.groups.filter(g => needs_answer(g)); // choice always comes back as undefined
            return q.groups.filter(g => needs_answer(g)).length > 0;
        }

        if (q.type == "set")
        {
            return false;
        }
        
        return true;
    }

    let allQuestionsAnswered = (page) => {

        if (!page || !page.content) {
            return false;
        }

        let content = page.content.filter(c => c.type && needs_answer(c));
        return content.length === 0
    }

    function handleSubmit() {
        goToNextPage()

        var url = new URL(window.location.href);
        var cx = url.searchParams.get("context");
        if (cx) {
            navigate(`/?name=${diagnosis}&context=${cx}`, { state: {
                page: page
            }});
        } else {
            navigate(`/?name=${diagnosis}`, { state: {
                page: page
            }});
        }
    }

    function sortClicked(e) {
        let el = e.target;
        while (el && el !== e.currentTarget && el.tagName !== "SPAN") {
            el = el.parentNode;
        }
        if (el && el.tagName === "SPAN" && algorithm.ref_pdf != "") {
            togglePDF(algorithm.ref_pdf)
        }
    }

    function withDualStain(cytology, ds) {
        if (ds && ds != "None") {
            return " and " + ds.toLowerCase();
        } else if (cytology == "None") {
            return " or dual stain results";
        }
        return "";
    }

    function withEG(extended) {
        if (extended) {
            return "<p class='ml-5 mb-0'><i class='test-subtitle'>Extended genotyped (" + extended + ")</p>";
        }
        return '';
    }
    
    function testToText(hpv, cytology, ds, prior) {
        if (hpv != "None") {
            var extended = ""
            var qualifier = "";
            if (hpv == "HPV16-18-Else+") {
                hpv = "HPV other positive";
            } else if (hpv == "HPV+ (untyped or other genotyping)") {
                hpv = "Positive";
            } else if (hpv == "HPV16-18+" || hpv == "HPV 18+") {
                hpv = "HPV18 positive";
            } else if (hpv == "HPV16+" || hpv == "HPV 16+") {
                hpv = "HPV16 positive";
            } else if (hpv == "HPV-") {
                hpv = "Negative";
            } else if (hpv == "HPV+ (56/59/66)") {
                hpv = "Positive";
                extended = "56/59/66";
            } else if (hpv && hpv.startsWith("HPV+ (untyped)")) {
                hpv = "Positive";
                qualifier = " (untyped)";
            } else if (hpv && hpv.startsWith("HPV+ (16/18 n")) {
                hpv = "Positive";
                extended = "other high-risk HPV+";
            } else if (hpv && hpv.startsWith("HPV+ (31/33/35/39/45/51/52/58/68)")) {
                hpv = "Positive";
                extended = "31/33/35/39/45/51/52/58/68";
            } else if (hpv && hpv.startsWith("HPV+")) {
                hpv = "Positive";
            }

            if (hpv == "Negative" && cytology == "Normal") {
                return "Cotest with a negative HPV test and normal cytology";
            } else if (hpv == "Negative" && cytology == "None") {
                return "Negative HPV test";
            } else if (hpv == "Negative") {
                return "Cotest with negative HPV and abnormal cytology result of " + cytology;
            } else if (hpv == "Positive" && cytology == "Normal") {
                return "Cotest with a positive HPV"+qualifier+" test and normal cytology" + withDualStain(cytology, ds) + withEG(extended);
            } else if (hpv == "Positive" && cytology == "None") {
                return "Positive HPV"+qualifier+" test without cytology" + withDualStain(cytology, ds) + withEG(extended);
            } else if (hpv == "Positive" && cytology.indexOf("Dual") >= 0) {
                cytology = cytology.replace(" +", " Positive");
                cytology = cytology.replace(" -", " Negative");
                return "Cotest with positive HPV"+qualifier+" and " + cytology.toLowerCase() + withEG(extended);
            } else if (hpv == "Positive") {
                return "Cotest with positive HPV"+qualifier+" and abnormal cytology result of " + cytology + withDualStain(cytology, ds) + withEG(extended);
            } else if (cytology == "Normal") {
                return "Cotest with a " + hpv + " result and normal cytology" + withDualStain(cytology, ds) + withEG(extended);
            } else if (cytology == "None") {
                // All the HPV Negative should have been handled, and we're talking about a specific type of Positive (16 or 18, etc)
                return hpv + " test without cytology" + withDualStain(cytology, ds) + withEG(extended);
            }

            return "Cotest with a " + hpv + " result and abnormal cytology result of " + cytology + withDualStain(cytology, ds) + withEG(extended);
        }

        if (prior) {
            return cytology;
        }
        if (cytology == "Normal") {
            return "Cytology-only test with a normal result";
        }
        if (cytology.startsWith("No History")) {
            return cytology;
        }
        if (cytology == "None") {
            return null;
        }
        return "Cytology-only test with an abnormal result of " + cytology;
      }

    function sectionContent(figures) {
        calcIndex = 0;

        if (page.state == "confirmation") {
            console.log(page.variables);
            page.content = [];
            
            page.content.push({
                "visible": true,
                "type": "overlay",
                "style": "confirmation",
                "title": "Confirmation",
                "text":   "<b>Age: " + page.variables['patient_age'] + "</b>" + "<br>" + 
                    "<b>Clinical Situation: " + page.variables['clinical_situation'] + "</b>"
            });
            
            let current_cytology = page.variables['_cytology'] || page.variables['current_cytology'] || page.variables['pos_both'];
            let hpv = page.variables['current_hpv'] || page.variables['hpv'];
            if (hpv && 
                current_cytology &&
                (hpv != 'None' || 
                current_cytology != 'None' || 
                page.variables['current_ds'] != 'None')) {

                let text = testToText(page.variables['current_hpv'], 
                    current_cytology,
                    page.variables['current_ds'],
                    false);
                if (text) {
                    page.content.push({
                        "visible": true,
                        "type": "overlay",
                        "title": "Current results",
                        "style": "current",
                        "text": text
                    });
                }
            } else if (hpv && 
                (hpv != 'None' || 
                page.variables['current_ds'] != 'None')) {
                
                let text = testToText(page.variables['current_hpv'], 
                    'None',
                    page.variables['current_ds'],
                    false)
                if (text) {
                    page.content.push({
                        "visible": true,
                        "type": "overlay",
                        "title": "Current results",
                        "style": "current",
                        "text": text
                    });
                }
            }

            if (page.variables['prior_v'] &&
                page.variables['prior_hpv'] && 
                page.variables['prior_cytology'] &&
                (page.variables['prior_hpv'] != 'None' || 
                 page.variables['prior_cytology'] != 'None' || 
                 page.variables['prior_ds'] != 'None')) {
                    var text = testToText(page.variables['prior_hpv'], 
                        page.variables['prior_cytology'],
                        page.variables['prior_ds'],
                        false);
                    if (!text) {
                        text = "Unknown";
                    }

                page.content.push({
                    "visible": true,
                    "type": "overlay",
                    "title": "Prior results",
                    "style": "prior",
                    "text": text
                });
            } else if (page.variables['prior_v'] && page.variables['prior']) {
                page.content.push({
                    "visible": true,
                    "type": "overlay",
                    "title": "Prior results",
                    "style": "prior",
                    "text": page.variables['prior']
                });
            }

            if (page.variables['clinical_situation'] == "Follow-up after treatment") {
                page.content.push({
                    "visible": true,
                    "type": "overlay",
                    "title": "Treatment",
                    "style": "treated",
                    "text": "Treatment with a histologic result of " + (page.variables['_colpo'] || page.variables['colpo'])
                });
            } else if (page.variables['_colpo'] || page.variables['colpo']) {
                let treatment = page.variables['treatment'] || page.variables['cytoResult'];
                if (treatment && treatment.startsWith("No-")) {
                    page.content.push({
                        "visible": true,
                        "type": "overlay",
                        "title": "Colposcopy",
                        "style": "colposcopy",
                         "text": "Colposcopy with a biopsy of " + (page.variables['_colpo'] || page.variables['colpo']) + " (Observation)"
                    });
                } else {
                    page.content.push({
                        "visible": true,
                        "type": "overlay",
                        "title": "Colposcopy",
                        "style": "colposcopy",
                        "text": "Colposcopy with a biopsy of " + (page.variables['_colpo'] || page.variables['colpo'])
                    });
                }
            }
            
            if (page.variables['treatment_v'] || page.variables['cytoResult_v']) {
                let treatment = page.variables['treatment'] || page.variables['cytoResult'];
                if (!treatment || !treatment.startsWith("Yes-") && !treatment.startsWith("No-")) {
                    page.content.push({
                        "visible": true,
                        "type": "overlay",
                        "title": "Cytology prior",
                        "style": "prior_cyto",
                        "text": treatment
                    });
                }
            }
        }

        var content = (
            (page.content || []).map((c) => mapContent(c, diagnoses, facts, setVariable, getVariable, page.state, page.variables["diagnosis"], sortClicked, algorithm, setcalResult, page.references, togglePDF, figures))
        )
        return content;
    }

    let medication = page.state === "medication";
    let recommendation = page.state === "recommendation";
    let flow = !recommendation && allQuestionsAnswered(page);
    let isDiagnosis = (page.title == "Diagnosis") && allQuestionsAnswered(page);
    let variables = page.variables || {};

    let diagnosis = variables["diagnosis"];
    var figures = page.figure || [];
    let short = variables["short"] || '';
    let navigate = useNavigate();
    page.references = [];
    page.populations = [];
    
    let content = page.content || [];
    for(var i=0;i<content.length;i++) {
        var c = content[i];

        if (c.reference && c.reference.length > 0) {
            c.reference.split(',').forEach(r => page.references.push(r.trim()));
        }
        if (c.followup_reference && c.followup_reference.length > 0) {
            c.followup_reference.split(',').forEach(r => page.references.push(r.trim()));
        }
        if (c.info && c.info.length > 0) {
            c.info.forEach( ii => {
                if (ii.reference && ii.reference.length > 0) {
                    ii.reference.split(',').forEach(r => page.references.push(r.trim()));
                }
            });
        }
        if (c.risk_reference && c.risk_reference.length > 0) {
            c.risk_reference.split(',').forEach(r => page.references.push(r.trim()));
        }
        if (c.risk_info && c.risk_info.length > 0) {
            c.risk_info.forEach( ii => {
                if (ii.reference && ii.reference.length > 0) {
                    ii.reference.split(',').forEach(r => page.references.push(r.trim()));
                }
            });
        }
        if (c.populations && c.populations.length > 0) {
            page.populations =  page.populations.concat(c.populations);
        }
    }
    page.references = page.references.filter(onlyUnique);
    page.populations = page.populations.filter(onlyUnique);
    figures = figures.filter(f => f && f.length > 3);

    var ex_styles = 'question-section grid-container';
    if (figures && figures.length > 0) {
        ex_styles += '-2';
    }

    return (
        <div id="guided_page">
            {!recommendation ? <div className="question-section">
                {sectionContent(figures)}
                {(page.title == "Diagnosis" || page.title == "Switching" || page.type == "section" || !window.location.href.includes("?name") && !medication) ? "" : <BackFlow goToPrevPage={goToPrevPage}/> }
                {isDiagnosis ? <Flow goToNextPage={handleSubmit}></Flow> : flow ? <Flow goToNextPage={goToNextPage} /> : ""}
            </div> : 
            <div>
                <div className={ex_styles} style={{paddingTop:"30px"}}>
                    <div>
                        <h2>{short} Recommendation</h2>
                        {sectionContent(figures)}
                    </div>
                    {recommendation && figures && figures.length > 0 ? (
                    <div>
                        <h2 style={{paddingLeft:"28px"}}>Figure</h2>
                        {setcalResult == null ? renderFigures(figures) : ""}
                    </div>
                    ) : null}
                </div>
            </div>}
            {recommendation && page.populations && page.populations.length > 0 ? (
                <div>
                    <h2 style={{paddingTop:"20px"}}>Special Populations</h2>
                    <div style={{gridTemplateColumns:"repeat(auto-fit, minmax(min-content, 48%))"}} className='grid-container'>
                        {renderPopulations(page.populations)}
                    </div>
                </div>
            ) : null}
            {recommendation && page.references && page.references.length > 0 ? (
                <div>
                    <h2 style={{paddingTop:"20px"}}>References</h2>
                    <div style={{gridTemplateColumns:"repeat(auto-fit, minmax(min-content, 48%))"}} className='grid-container'>
                        {renderReferences(page.references)}
                    </div>
                </div>
            ) : null}
            {recommendation ? <div id="button-bar">
                    <BackFlow goToPrevPage={goToPrevPage} margin="0px 10px 0px 0px"/>
                    <StartOverFlow startOver={startOver} margin="0px 10px 0px 0px"/>
                </div> : ""}

        </div>
    )
};

export default Page